import React from 'react';
import PropTypes from 'prop-types';
import {Header} from '../../../Header';
import {ModalFooter} from '../ModalFooter';
import {ModalContent} from '../ModalContent';
import {SectionLeft} from '../SectionLeft';
import {ContentDescription} from '../ContentDescription';
import {BalanceStatusBlock} from '../BalanceStatusBlock';
import {SectionRight} from '../SectionRight';
import {ControlsPanel} from '../ControlsPanel';
import {Modal} from '@learningblocks/storybook-components';
import {
  NOTIFY_EVENTS,
  getTimeValues,
  getNewTime,
} from '../Microcentrifuge.utils';
import './style.scss';

const COUNT_DOWN_RATE = -1;
const COUNT_DOWN_INTERVAL = 25;

export function MicroControlsModal(props) {
  const [centrifugeStatus, setCentrifugeStatus] = React.useState({
    running: false,
    timeLeft: null,
  });

  if (centrifugeStatus.running) {
    const [sec, min, hour] = getTimeValues(centrifugeStatus.timeLeft);
    if (sec || min || hour) {
      const newTime = getNewTime(centrifugeStatus.timeLeft, COUNT_DOWN_RATE);
      setTimeout(
        () => setCentrifugeStatus({running: true, timeLeft: newTime}),
        COUNT_DOWN_INTERVAL
      );
    } else {
      setTimeout(
        () => setCentrifugeStatus({running: false, timeLeft: null}),
        COUNT_DOWN_INTERVAL
      );
    }
  }

  const onRunCentrifuge = () => {
    if (props.centrifugeRunnable) {
      if (!centrifugeStatus.running) {
        setCentrifugeStatus({running: true, timeLeft: props.timeLeft});
        props.runCentrifuge();
      }
    } else {
      props.alert(NOTIFY_EVENTS.NOT_RUNNABLE);
    }
  };

  const setTimeLeft = () => {
    if (centrifugeStatus.running) {
      return centrifugeStatus.timeLeft;
    } else {
      return props.timeLeft;
    }
  };

  const setCallback = (callback) => (params) => {
    if (centrifugeStatus.running) {
      props.alert(NOTIFY_EVENTS.NOT_ALLOWED_CENTRIFUGE_RUNNING);
    } else {
      callback(params);
    }
  };

  return (
    <Modal isOpen={props.isOpen} size={props.size}>
      <div className='controlsModal'>
        <Header
          label='THE MICROCENTRIFUGE (SETTINGS)'
          close={props.onClose}
          size='md'
        />
        <ModalContent className='controlsModal_content'>
          <SectionLeft className='controlsModal_content_left'>
            <ContentDescription
              className='controlsModal_content_left_contentDescription'
              title='Program the microcentrifuge'
              description="Set the time and rotations per minute, then click 'Start'. Once it is running, click 'Back'."
            />
            <BalanceStatusBlock
              balanced={props.balanced}
              className='controlsModal_content_left_warning'
            />
          </SectionLeft>
          <SectionRight className='controlsModal_content_right'>
            <ControlsPanel
              className='controlsModal_content_right_panel'
              rpmValue={props.rpmValue}
              balanced={props.balanced}
              timeValue={props.timeValue}
              timeLeft={setTimeLeft()}
              setRPM={setCallback(props.setRPM)}
              setTimeValue={setCallback(props.setTimeValue)}
              runCentrifuge={onRunCentrifuge}
              alert={props.alert}
              onPulseSolutions={props.onPulseSolutions}
            />
          </SectionRight>
        </ModalContent>
        <ModalFooter
          text='Back'
          className='controlsModal_footer'
          onClick={props.onClose}
        />
      </div>
    </Modal>
  );
}

MicroControlsModal.propTypes = {
  /**
   * Function to alert event
   */
  alert: PropTypes.func,
  /**
   * Boolen to set if modal is displayed
   */
  isOpen: PropTypes.bool,
  /**
   * Function to invoke to close the modal
   */
  onClose: PropTypes.func,
  /**
   * Boolean to set if the Microcentrifuge tubes are balanced
   */
  balanced: PropTypes.bool,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
  /**
   * Boolean to determine if centrifuge runnable
   */
  centrifugeRunnable: PropTypes.bool,
};

MicroControlsModal.defaultProps = {
  showClose: true,
  size: 'md',
};
